import { IndisponibilityService } from '@core/infrastructure/api/services';
import IUseCase from '../../IUseCase';
import { AxiosResponse } from 'axios';

export default class CheckIndisponibility implements IUseCase<void, Promise<AxiosResponse>> {
  execute(): Promise<AxiosResponse> {
    return IndisponibilityService.checkIndisponibility()
  }
}
